import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function PainSection() {
  const painPoints = ['Seguiste una receta al pie de la letra y la masa quedó dura, gomosa o se rompió al estirar', 'Hiciste el merengue y a las 2 horas ya estaba líquido y la milhojas arruinada', 'Le quedó perfecta a todos menos a vos y no entendés qué estás haciendo mal', 'Querés sorprender en un cumpleaños o reunión pero le tenés miedo a quedar en ridículo', 'Buscaste mil recetas en YouTube y ninguna te explicó los DETALLES que realmente importan'];
  return <section className="bg-brand-dark py-20 md:py-28 relative" data-id="element-335">
      <div className="max-w-4xl mx-auto px-4" data-id="element-336">
        <FadeIn data-id="element-337">
          <h2 className="text-3xl md:text-5xl font-bold text-brand-cream text-center mb-16" data-id="element-338">
            ¿Te pasó alguna vez esto?
          </h2>
        </FadeIn>

        <div className="space-y-6 mb-16" data-id="element-339">
          {painPoints.map((point, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-340">
              <div className="bg-brand-dark-deep/50 border border-brand-gold/10 p-6 rounded-xl flex items-start" data-id="element-341">
                <span className="text-2xl mr-4 flex-shrink-0 mt-1" data-id="element-342">😤</span>
                <p className="text-brand-cream/90 text-lg md:text-xl leading-relaxed" data-id="element-343">
                  {point}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-344">
          <div className="text-center max-w-3xl mx-auto" data-id="element-345">
            <p className="text-xl md:text-2xl text-brand-gold font-serif italic leading-relaxed" data-id="element-346">
              "No es tu culpa. La mayoría de las recetas que circulan en
              internet omiten los secretos técnicos que hacen la diferencia
              entre una milhojas mediocre y una que deja a todos sin palabras."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}